/* eslint-disable */
// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
  aws_app_analytics: 'enable',
  aws_cognito_identity_pool_id: 'us-east-1:a8259204-b6df-4abd-bf13-dccc836a671c',
  aws_cognito_region: 'us-east-1',
  aws_content_delivery: 'enable',
  aws_content_delivery_bucket: 'ahamove-hosting-mobilehub-695308509',
  aws_content_delivery_bucket_region: 'us-east-1',
  aws_content_delivery_cloudfront: 'enable',
  aws_content_delivery_cloudfront_domain: 'dm9f9womec4nc.cloudfront.net',
  aws_mobile_analytics_app_id: 'c8bc94fe23a84a63bb59083f81a739b3',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_project_id: '07bdf0f9-8974-468e-bbc3-5b2e05ba71a9',
  aws_project_name: 'ahamove',
  aws_project_region: 'us-east-1',
  aws_resource_name_prefix: 'ahamove-mobilehub-695308509'
}

export default awsmobile
